import React from "react";
import { withRouter } from "react-router";
import TitleBar from "../../../components/common/title_bar";
import SearchFilter from "../../../components/filters/SearchFilter";
import MarcasPopup from "./MarcasPopup";
import MarcasTable from "./MarcasTable";
import * as $ from "jquery";

class MarcasCommon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            marcasPopup: "",
            applyedfilter: {},
            date: new Date(),
        };
    }

    componentDidMount() {
        this.createState();
        $(window).scrollTop(0);
    }

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            $(window).scrollTop(0);
            this.createState();
        }
    }

    createState = () => {
        this.setState({
            entity_details: {},
            applyedfilter: {},
            filters: this.props.linkData.filters,
        });
    };

    getFilters = (customfilters) => {
        console.log("filter 800", customfilters.filters);
        const { filters } = customfilters;
        let applyedfilter = {};
        Object.keys(filters).map((item) => {
            if (item === "Código de Marca") {
                applyedfilter["brandCode"] = +filters[item];
            } else if (item === "Nome de Marca") {
                applyedfilter["brandName"] = filters[item];
            } else if (item === "Numero de Entidade") {
                applyedfilter["entidadeNIF"] = +filters[item];
            } else if (item === "Nome de Entidade") {
                applyedfilter["entidadeName"] = filters[item];
            } else if (item === "Nº Processo") {
                applyedfilter["processNumber"] = +filters[item];
            }
        });
        delete applyedfilter.entity;
        applyedfilter.local = window.localStorage.getItem("Local");
        console.log("filter", applyedfilter);
        this.setState({
            applyedfilter,
            date: new Date(),
        });
    };

    actionPerform = (action, row) => {
        console.log("xxxxxxxxxxxxx=========>", action, row);
        if (action === "pending") {
            this.props.history.push({
                pathname: "/marcas_n_d_processo",
                search: `?from=${window.location.pathname.substr(1)}&estado=${
                    row.estado
                }&id=${row.idMarca}&tdp=Tipo de marca: ${
                    row.tipoMarca
                }&evaluator=1&processo=${row.marca}`,
            });
        } else if (action === "approved") {
            this.props.history.push({
                pathname: "/marcas_n_d_processo",
                search: `?from=${window.location.pathname.substr(1)}&estado=${
                    row.estado
                }&id=${row.idMarca}&tdp=Tipo de marca: ${
                    row.tipoMarca
                }&evaluator=1&processo=${row.marca}`,
            });
        } else if (action === "history") {
            this.props.history.push({
                pathname: "/marcas_n_d_processo",
                search: `?from=${window.location.pathname.substr(1)}&estado=${
                    row.Estado
                }&id=${row.idMarcaRequest}&tdp=Tipo de marca: ${
                    row.tipoMarcaDetalhe
                }&processo=${row.marca}`,
            });
        }
    };

    handleFilter = (data) => {
        console.log("data in the common 800", data);
    };

    render() {
        console.log("Tablename", this.props.linkData.tableName);
        return (
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        onlyInicioLink={"/marcasPendentes"}
                        path={this.props.linkData.TitleBarpath}
                        title={this.props.linkData.TitleBartitle}
                        logo={"marcas"}
                        prevPageName={this.props.linkData.prevPageName}
                        prevPageLink={this.props.linkData.prevPageLink}
                        linkData={this.props.linkData}
                        noOption={true}
                        // changeOption={(mainIndex, subIndex) =>
                        //     this.props.changeOption(mainIndex, subIndex)
                        // }
                        optionMenuArray={this.props.optionMenuArray}
                    />
                    {/* {this.props.linkData.filters &&
                        Object.keys(this.props.linkData.filters).length > 0 && (
                            <SearchFilter
                                tableName={this.props.tableName}
                                filters={this.props.linkData.filters}
                                getFilter={(data) => this.getFilters(data)}
                                data={this.state.data}
                                showMarcasSearch={true}
                                searchplaceholder={
                                    "Pesquisa por número de processo"
                                }
                                handleFilter={(data) => this.handleFilter(data)}
                            />
                        )} */}
                    <MarcasTable
                        date={this.state.date}
                        tableName={this.props.tableName}
                        actionPerform={this.actionPerform}
                        applyedfilter={this.state.applyedfilter}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(MarcasCommon);
